import './widget.less';
import exportIcon from './export.svg';
import b_ from 'b_';
import React from 'react';
import { observer } from 'mobx-react';

import { WidgetProps } from 'controls/designer/features/widgets/widgetProps';
import { DefaultWidgetWrapper } from 'controls/designer/features/widgets/defaultWidgetWrapper';
import { ExportWidgetConfig } from 'controls/designer/features/widgets/export/types';
import { ExportGridWindowStore } from 'controls/designer/features/widgets/export/exportGridWindowStore';
import { i18n } from './localization';
import { RedirectType } from 'controls/designer/features/redirectOnClick/redirectType';


const b = b_.with('export-widget');

const ExportWidget = class InnerWidget extends React.Component<WidgetProps<ExportWidgetConfig>> {
	store: ExportGridWindowStore;

	constructor(props: WidgetProps<ExportWidgetConfig>) {
		super(props);
		this.store = new ExportGridWindowStore(props.designer.store);
	}

	render() {
		return (
			<DefaultWidgetWrapper {...this.props} containerClass={b()} showHeader={false}>
				<img
					className={b('icon')}
					src={exportIcon}
					alt={i18n('Export')}
					title={i18n('Export')}
					onClick={this.onIconClick}
				/>
			</DefaultWidgetWrapper>
		);
	}

	componentWillUnmount() {
		this.store.destroy();
	}

	onIconClick = () => {
		const redirectType = this.props.redirectConfig?.type;
		if (redirectType == null || redirectType == RedirectType.Default || redirectType == RedirectType.None) {
			if (this.props.dashboardSettings.readOnly) {
				void this.store.open();
			}
			return;
		}

		this.props.navigator.go({});
	};
};

export default observer(ExportWidget);
